var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mode-title",class:{ row: _vm.row, center: _vm.algin == 'center', left: _vm.algin == 'left' }},[_c('div',{staticClass:"title-content-wrap"},[_c('ModeTitleImg',{attrs:{"title":_vm.title}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }